import ReportFilter from "./components/ReportFilter";
import ReportHeader from "./components/ReportHeader.vue";
import ReportBasedOnExpensesWidget from "./components/ReportBasedOnExpensesWidget.vue";
import DecryptionReportBasedOnAssets from "./components/DecryptionReportBasedOnAssets.vue";
import DecryptionReportBasedOnExpenses from "./components/DecryptionReportBasedOnExpenses.vue";
import DecryptionReportBasedOnAssetsAndExpenses from "./components/DecryptionReportBasedOnAssetsAndExpenses";
import SummaryReportForContractsWithSimplification from "./components/SummaryReportForContractsWithSimplification.vue";
import ReportHeaderFilterWithoutContract from "./components/ReportHeaderFilterWithoutContract.vue";
import SummaryReportBasedOnLiabilities from "./components/SummaryReportBasedOnLiabilities.vue";
import SummaryReportBasedOnCashOutflows from "./components/SummaryReportBasedOnCashOutflows.vue";
import SummaryReportBasedOnLiabilitiesMaturity from "./components/SummaryReportBasedOnLiabilitiesMaturity.vue";

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }
    // options.store.registerModule('discountRatesPlugin', discountRateStore);

    Vue.component('ReportFilter', ReportFilter);
    Vue.component('ReportHeader', ReportHeader);
    Vue.component('ReportHeaderFilterWithoutContract', ReportHeaderFilterWithoutContract);

    Vue.component('ReportBasedOnExpensesWidget', ReportBasedOnExpensesWidget);
    Vue.component('DecryptionReportBasedOnAssets', DecryptionReportBasedOnAssets);
    Vue.component('DecryptionReportBasedOnExpenses', DecryptionReportBasedOnExpenses);
    Vue.component('DecryptionReportBasedOnAssetsAndExpenses', DecryptionReportBasedOnAssetsAndExpenses);
    Vue.component('SummaryReportForContractsWithSimplification', SummaryReportForContractsWithSimplification);
    Vue.component('SummaryReportBasedOnLiabilities', SummaryReportBasedOnLiabilities);
    Vue.component('SummaryReportBasedOnCashOutflows', SummaryReportBasedOnCashOutflows);
    Vue.component('SummaryReportBasedOnLiabilitiesMaturity', SummaryReportBasedOnLiabilitiesMaturity);
  },
};
